import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
// eslint-disable-next-line import/no-unresolved
import { registerSW } from "virtual:pwa-register";

import { App } from "./app";
import "./index.css";
import { reportWebVitals } from "./reportWebVitals";
import { store } from "./store";

const PRELOAD_ERROR_RELOAD_KEY = "vite-preload-error-reload-at";
const PRELOAD_ERROR_RELOAD_COOLDOWN = 30_000;

window.addEventListener("vite:preloadError", (event) => {
  event.preventDefault();

  const lastReloadAt = Number(sessionStorage.getItem(PRELOAD_ERROR_RELOAD_KEY));
  if (Date.now() - lastReloadAt < PRELOAD_ERROR_RELOAD_COOLDOWN) {
    return;
  }

  sessionStorage.setItem(PRELOAD_ERROR_RELOAD_KEY, String(Date.now()));
  window.location.reload();
});

registerSW({ immediate: true });

createRoot(document.getElementById("root") as HTMLElement).render(
  <Provider store={store}>
    <App />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
